export const GET_CASE_DELAY_SEVERITY_QUERY_KEY = "caseDelaySeverity";
export const GET_CASE_DELAY_BREAKDOWN_QUERY_KEY =
  "GET_CASE_DELAY_BREAKDOWN_QUERY_KEY";
export const GET_ALL_OVERVIEW_METRICS_QUERY_KEY = "analytics/all-metrics";
export const GET_CASE_INTERVAL_QUERY_KEY = "analytics/case-intervals";
export const GET_OT_TIME_BREAKDOWN_QUERY_KEY = "analytics/ot-time-breakdown";
export const GET_OTS_QUERY_KEY = "admin/:hospital/ots";
export const GET_PROCEDURES_QUERY_KEY = "admin/:hospital/procedures";
export const GET_CASE_IDS_QUERY_KEY = "users/all";
export const GET_ANALYTICS_PROCEDURE_QUERY_KEY =
  "analytics/case-count/procedure";
export const GET_MASTER_TABLE_DATA_QUERY_KEY = "analytics/master-data?page=";
export const GET_MASTER_TABLE_COLUMN_QUERY_KEY =
  "analytics/master-data/columns";
export const GET_CASES_QUERY_KEY = "getCases";
export const GET_CASES_PER_OT_QUERY_KEY = "analytics/cases-per-ot";
export const GET_AVG_CASES_PER_ACTIVE_DAY_QUERY_KEY =
  "analytics/average-cases-per-active-day";
export const GET_AVG_CASE_DURATION_QUERY_KEY =
  "analytics/average-case-duration";
export const GET_AVG_TURNOVER_TIME_QUERY_KEY =
  "analytics/average-turnover-time";
export const GET_OT_UTILIZATION_QUERY_KEY = "analytics/ot-utilization-combined";
export const GET_ON_TIME_START_END_PERCENTAGE_QUERY_KEY =
  "analytics/on-time-start-end-percentage";
export const GET_SURGICAL_VS_TOTAL_CASE_TIME_QUERY_KEY =
  "surgicalVsTotalCaseTime";
export const GET_ON_TIME_STARTS_ENDS_FOR_SURGEONS_QUERY_KEY =
  "onTimeStartsEndsForSurgeons";
export const GET_READY_TO_INCISION_LAG_QUERY_KEY = "readyToIncisionLag";
export const GET_CASES_MOVED_PER_OT_QUERY_KEY = "casesMovedPerOt";
export const GET_CASE_INDUCTION_TIME_QUERY_KEY = "caseInductionTime";
export const GET_ANESTHESIA_START_TO_PROCEDURE_START_INTERVAL_QUERY_KEY = "anesthesiaStartToProcedureStartInterval";
export const GET_ANESTHESIA_START_INTERVAL_QUERY_KEY =
  "AnesthesiaStartInterval";
export const GET_CASE_RECOVERY_HANDOFF_TIME_QUERY_KEY = "RecoveryHandoffTime";
export const GET_CASES_PER_CIRCULATING_NURSE_QUERY_KEY =
  "analytics/circulating-nurse-cases";
export const GET_NURSE_VOICE_PER_OT_QUERY_KEY = "analytics/nurse-voice-notes";
export const GET_AVG_CASES_PER_ACTIVE_DAY_NURSE_QUERY_KEY =
  "analytics/average-cases-per-active-day";
export const GET_ON_TIME_STARTS_ENDS_FOR_NURSE_QUERY_KEY =
  "analytics/on-time-starts-ends-for-nurses";
export const GET_FILTER_OTS_QUERY_KEY = "analytics/filter-options/ots";
export const GET_FILTER_CASE_ID_QUERY_KEY = "analytics/filter-options/case-id";
export const GET_FILTER_SURGEON_QUERY_KEY = "analytics/filter-options/surgeons";
export const GET_FILTER_PROCEDURES_QUERY_KEY ="analytics/filter-options/procedures";
export const GET_FILTER_ANESTHESIOLOGIST_QUERY_KEY = "analytics/filter-options/anesthesiologists";
export const GET_FILTER_CIRCULATING_NURSE_QUERY_KEY = "analytics/filter-options/circulating-nurses";
export const GET_FILTER_DELAY_CATEGORIES_QUERY_KEY = "analytics/filter-options/delay-categories";
export const GET_FILTER_MRN_QUERY_KEY = "analytics/filter-options/mrn";
export const GET_SAVE_FILTER_QUERY_KEY = "save-filter";
export const GET_FILTER_QUERY_KEY = "FILTER_DATA";



export type OVERVIEW_METICS = {
  label: string;
  value: number;
};

export type FILTER_STATE = {
  dateRange: {
    from?: Date | string | null;
    to?: Date | string | null;
  };
  ots: Array<string>;
  procedureIds: Array<string>;
  attendingSurgeonNames: Array<string>;
  nurseIds: Array<string>;
  caseIds: Array<string>;
  otsKeys: Array<string>;
  procedureKeys: Array<string>;
  nurseKeys: Array<string>;
  assignedAnesthesiologist: Array<string>;
  anaesthelogistNameList: Array<string>;
  caseStartDelay: Array<string>;
  caseOrder: string | null;
  autoClosed: string | null;
  inconsistentTimestamps?: string | null;
  antibioticUsed?: string | null;
  excludeOts: Array<string>;
  excludeProcedureIds: Array<string>;
  excludeAttendingSurgeonNames: Array<string>;
  excludeNurseIds: Array<string>;
  excludeAssignedAnesthesiologist: Array<string>;
  excludeDelayCategories: Array<string>;
  excludeCaseOrder: string | null;
  excludeCaseIds: Array<string>;
  excludeAutoClosed: string | null;
  advanceFilters?: Array<{
    field: string;
    operator?: string;
    values?: Array<{ id: string; name?: string }>;
  }>;
};

export type CASE_DETAIL = {
  index: number;
  caseId: number;
  delayMinutes: number;
};

export type CASE_DELAY_SEVERITY = {
  totalCases: number;
  totalDelayMinutes: number;
  cases: CASE_DETAIL[];
  otRoom: string;
  otName: string;
};

export type MASTER_TABLE_COLUMN_ITEM = {
  field: string;
  label: string;
  category: string;
  alwaysDisplayed: boolean;
  visible: boolean;
  order: number;
};

export type MASTER_TABLE_ITEM = {
  id: string;
  caseId: number;
  otId: string;
  geographicSource: string;
  mdName: string;
  otName: string;
  user: string;
  procedureName: string;
  milestoneName: string;
  fullCaseScheduledStartDateTime: string;
  anaesthesiaStart: string;
  patientAsleep: string;
  patientAwake: string;
  timeoutTimestamp: string;
  durationRoomReadyToWheelsIn: number;
  durationWheelsInToPatientReady: number;
  durationPatientReadyToProcedureStart: number;
  durationProcedureStartToProcedureEnd: number;
  durationProcedureEndToWheelsOut: number;
  roomCleaningTime: number;
  turnoverTime: number;
  totalCaseTime: number;
  procedureStart: string;
  procedureEnd: string;
  createdAt: string;
  updatedAt: string;
  hospitalId: string;
  tenantId: string;
  lastCaseTag: boolean;
  roomSetupTime: number;
  surgeonTurnoverTime: number;
  caseDelay?: number;
  durationWheelsOutToRoomClean: 0;
  durationRoomCleanStartToEnd: 0;
  endTimeVariance: 0;
  caseRank: 1;
  remarks: string;
  patientMrn: string;
  additionalProceduresCount: number;
  caseScheduleStart: Date | string | null;
  caseTiming: Date | string | null;
  roomReadyTimestamp: Date | string | null;
  wheelsInTimestamp: Date | string | null;
  anesthesiaStartTimestamp: Date | string | null;
  patientAsleepTimestamp: Date | string | null;
  patientReadyTimestamp: Date | string | null;
  procedureStartTimestamp: Date | string | null;
  procedureEndTimestamp: Date | string | null;
  patientAwakeTimestamp: Date | string | null;
  readyToExitTimestamp: Date | string | null;
  wheelsOutTimestamp: Date | string | null;
  roomCleanStartTimestamp: Date | string | null;
  roomCleanEndTimestamp: Date | string | null;
  durationProcedureEndToReadyToExit: number | null;
  durationRoomCleanEndToRoomReady: number | null;
  primarySurgeonStatus: null;
  secondSurgeon: string | null;
  thirdSurgeon: string | null;
  anesthesiaTechnicians: null;
  scrubNurses: string | Array<string> | null;
  equipments: string | Array<string> | null;
  operationType: string | null;
  procedureNature: string | null;
  speciality1: null;
  speciality2: null;
  anesthesiaType: string | Array<string>;
  antiobioticAdminTime: string | null;
  antibioticlt60MinPreIncision: null;
  implantsUsed: boolean | string | null;
  antibioticUsed?: boolean | string | null;
  woundStatus: null;
  startTimeCategory: string;
  endTimeCategory: string;
  inconsistentTimestamps?: boolean | string | null;
  milestonesSkipped?: boolean | string | null;
  nextPatientCallTimestamp?: Date | string | null;
  skippedAt?: Date | string | null;
};

// Analytics API response item types
export type OT_CASES_PER_OT = {
  otName: string;
  caseCount: number;
};

export type OT_AVG_CASES_PER_ACTIVE_DAY = {
  otName: string;
  totalCases: number;
};

export type OT_NURSE_AVG_CASES_PER_ACTIVE_DAY = {
  nurseId: number;
  nurseName: string;
  totalCases: number;
  numberOfActiveDays: number;
  avgCasesPerDay: number;
};

export type OT_AVG_CASE_DURATION = {
  otName: string;
  avgCaseDuration: number;
};

export type OT_AVG_TURNOVER_TIME = {
  otName: string;
  avgTurnoverTime: number;
};

export type OT_UTILIZATION = {
  otName: string;
  utilizationPercentage: number;
};

export type ON_TIME_START_END_PERCENTAGE_RESPONSE = {
  otName: string;
  percentOnTimeStarts: number;
  percentOnTimeEnds: number;
  totalCases: number;
};
